module.exports = __webpack_public_path__ + "img/reset_password_manager_icon.eb59c010.svg";